import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles,
  Divider
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '& h2': {
      color: theme.palette.primary.contrastText,
    }
  },
  questionSection: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  answerSection: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary[50],
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.primary[200]}`,
  },
  questionLabel: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    fontSize: '1.1rem',
  },
  answerLabel: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: theme.palette.secondary.main,
    fontSize: '1.1rem',
  },
  content: {
    padding: theme.spacing(2),
    maxHeight: '70vh',
    overflowY: 'auto',
  },
  questionAnswerPair: {
    marginBottom: theme.spacing(4),
    '&:last-child': {
      marginBottom: 0,
    }
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  questionText: {
    fontSize: '1rem',
    lineHeight: 1.6,
  },
  answerText: {
    fontSize: '1rem',
    lineHeight: 1.6,
  }
}));

interface QuestionAnswer {
  question: string;
  answer: string;
}

interface ExpertQuestionModalProps {
  open: boolean;
  onClose: () => void;
  questions: string | string[];
  answers: string | string[];
}

export default function ExpertQuestionModal({
  open,
  onClose,
  questions,
  answers
}: ExpertQuestionModalProps) {
  const classes = useStyles();

  const questionsArray = Array.isArray(questions) ? questions : [questions];
  const answersArray = Array.isArray(answers) ? answers : [answers];

  const questionAnswerPairs: QuestionAnswer[] = questionsArray.map((question, index) => ({
    question,
    answer: answersArray[index] || 'Ответ не найден'
  }));


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle className={classes.dialogTitle}>
        Ответы эксперта
      </DialogTitle>

      <DialogContent className={classes.content}>
        {questionAnswerPairs.map((pair, index) => (
          <Box key={index} className={classes.questionAnswerPair}>
            <Box className={classes.questionSection}>
              <Typography variant="h6" className={classes.questionLabel}>
                Вопрос {index + 1}:
              </Typography>
              <Typography variant="body1" className={classes.questionText}>
                {pair.question}
              </Typography>
            </Box>

            <Box className={classes.answerSection}>
              <Typography variant="h6" className={classes.answerLabel}>
                Ответ эксперта:
              </Typography>
              <Typography variant="body1" className={classes.answerText}>
                {pair.answer}
              </Typography>
            </Box>

            {index < questionAnswerPairs.length - 1 && (
              <Divider className={classes.divider} />
            )}
          </Box>
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
}
